import type { Venue } from '../../types/venue';

export const villaJohanneberg: Venue = {
  id: 'villa-johanneberg',
  name: 'Villa Johanneberg',
  description: {
    en: 'A historic mansion offering exclusive meetings in a serene environment in Gothenburg.',
    sv: 'En historisk herrgård som erbjuder exklusiva möten i en fridfull miljö i Göteborg.',
    no: 'En historisk herregård som tilbyr eksklusive møter i rolige omgivelser i Göteborg.',
    da: 'En historisk herregård, der tilbyder eksklusive møder i rolige omgivelser i Göteborg.'
  },
  image: '/assets/images/johanneberg.webp',
  country: 'se',
  region: 'gothenburg',
  city: 'Gothenburg',
  address: 'Viktor Rydbergsgatan 27, 412 57 Göteborg, Sweden',
  coordinates: {
    lat: 57.69406867572591,
    lng: 11.981311419979983
  },
  capacity: {
    min: 2,
    max: 50
  },
  rating: 4.4,
  reviews: Array.from({ length: 40 }, (_, i) => ({
    id: `review-${i}`,
    userId: `user-${i}`,
    rating: 4.4,
    comment: '',
    date: new Date().toISOString()
  })),
  amenities: ['wifi', 'coffee', 'restaurant'],
  images: [
    '/assets/images/johanneberg.webp'
  ],
  priceRange: {
    min: 1500,
    max: 15000
  },
  recommended: false
};